function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SidebarTemplate = require('./sidebar.template');
var Pot = require('./pot');
var Playerbox = require('./playerbox');
var Sidebar = /*#__PURE__*/function () {
  function Sidebar(app, mod) {
    _classCallCheck(this, Sidebar);
    this.app = app;
    this.mod = mod;
    this.pot = new Pot(app, mod);
    this.playerboxes = [];
  }
  return _createClass(Sidebar, [{
    key: "render",
    value: function render() {
      if (!this.mod.gameBrowserActive() && !this.mod.browser_active) {
        return;
      }
      if (!document.querySelector('.poker-sidebar')) {
        this.app.browser.addElementToSelector(SidebarTemplate(), '.poker-main');
      }
      this.pot.render();
      this.renderPlayerboxes();
      this.bindChipCryptoBalanceToggle();
    }

    /**
     * Shared touch/keyboard toggle for CHIP ↔ crypto balance faces
     * (player boxes, pot, and pot-details overlay when hosted in-page briefly).
     */
  }, {
    key: "bindChipCryptoBalanceToggle",
    value: function bindChipCryptoBalanceToggle() {
      if (this._chipCryptoToggleBound) {
        return;
      }
      var activate = function activate(el) {
        if (!(el !== null && el !== void 0 && el.classList.contains('chip-crypto-balance--toggle'))) {
          return;
        }
        el.classList.toggle('is-showing-crypto');
        var showing = el.classList.contains('is-showing-crypto');
        el.setAttribute('aria-pressed', showing ? 'true' : 'false');
        var cryptoFace = el.querySelector('.chip-crypto-balance-face--crypto');
        if (cryptoFace) {
          cryptoFace.setAttribute('aria-hidden', showing ? 'false' : 'true');
        }
      };

      // Capture on document so pot-details overlay (outside sidebar) also works.
      document.addEventListener('click', function (e) {
        var bal = e.target.closest('.chip-crypto-balance--toggle');
        if (!bal) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        activate(bal);
      }, true);
      document.addEventListener('keydown', function (e) {
        var _e$target$closest, _e$target;
        if (e.key !== 'Enter' && e.key !== ' ') {
          return;
        }
        var bal = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, '.chip-crypto-balance--toggle');
        if (!bal) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        activate(bal);
      });
      this._chipCryptoToggleBound = true;
    }
  }, {
    key: "renderPlayerboxes",
    value: function renderPlayerboxes() {
      var _this$mod$game;
      var n = ((_this$mod$game = this.mod.game) === null || _this$mod$game === void 0 || (_this$mod$game = _this$mod$game.players) === null || _this$mod$game === void 0 ? void 0 : _this$mod$game.length) || 0;
      while (this.playerboxes.length < n) {
        var i = this.playerboxes.length;
        this.playerboxes.push(new Playerbox(this.app, this.mod, this.mod.game.players[i], i + 1));
      }
      if (n > 0 && !this.mod.game.players.includes(this.mod.publicKey) && this.playerboxes.length == n) {
        this.playerboxes.push(new Playerbox(this.app, this.mod, this.mod.publicKey, 0));
      }
      for (var _i = 0; _i < this.playerboxes.length; _i++) {
        this.playerboxes[_i].render('.poker-sidebar');
      }
    }
  }, {
    key: "returnBox",
    value: function returnBox(player_number) {
      if (player_number == 0) {
        return this.playerboxes.find(function (box) {
          return box.player_number == 0;
        }) || null;
      }
      if (player_number > 0 && this.playerboxes.length >= player_number) {
        return this.playerboxes[player_number - 1];
      }
      return null;
    }
  }, {
    key: "addClass",
    value: function addClass(content, player_number) {
      var _this$returnBox;
      var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'game-playerbox';
      (_this$returnBox = this.returnBox(player_number)) === null || _this$returnBox === void 0 || _this$returnBox.addClass(content, target);
    }
  }, {
    key: "setAction",
    value: function setAction(action, player_number) {
      var _this$returnBox2;
      (_this$returnBox2 = this.returnBox(player_number)) === null || _this$returnBox2 === void 0 || _this$returnBox2.setAction(action);
    }
  }, {
    key: "setChips",
    value: function setChips(html, player_number) {
      var _this$returnBox3;
      (_this$returnBox3 = this.returnBox(player_number)) === null || _this$returnBox3 === void 0 || _this$returnBox3.setChips(html);
    }
  }, {
    key: "setRole",
    value: function setRole(role, player_number) {
      var _this$returnBox4;
      (_this$returnBox4 = this.returnBox(player_number)) === null || _this$returnBox4 === void 0 || _this$returnBox4.setRole(role);
    }
  }, {
    key: "updateBody",
    value: function updateBody(content, player_number) {
      var _this$returnBox5;
      (_this$returnBox5 = this.returnBox(player_number)) === null || _this$returnBox5 === void 0 || _this$returnBox5.updateBody(content);
    }
  }, {
    key: "updateGraphics",
    value: function updateGraphics(content, player_number) {
      var _this$returnBox6;
      (_this$returnBox6 = this.returnBox(player_number)) === null || _this$returnBox6 === void 0 || _this$returnBox6.updateGraphics(content);
    }
  }, {
    key: "replaceGraphics",
    value: function replaceGraphics(content, selector, player_number) {
      var _this$returnBox$repla, _this$returnBox7;
      return (_this$returnBox$repla = (_this$returnBox7 = this.returnBox(player_number)) === null || _this$returnBox7 === void 0 ? void 0 : _this$returnBox7.replaceGraphics(content, selector)) !== null && _this$returnBox$repla !== void 0 ? _this$returnBox$repla : null;
    }
  }, {
    key: "updateUserline",
    value: function updateUserline(userline, player_number) {
      var _this$returnBox8;
      (_this$returnBox8 = this.returnBox(player_number)) === null || _this$returnBox8 === void 0 || _this$returnBox8.updateUserline(userline);
    }
  }, {
    key: "updateIcons",
    value: function updateIcons(content, player_number) {
      var _this$returnBox9;
      (_this$returnBox9 = this.returnBox(player_number)) === null || _this$returnBox9 === void 0 || _this$returnBox9.updateIcons(content);
    }
  }, {
    key: "setActive",
    value: function setActive(player_number) {
      var deactivate_others = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (deactivate_others) {
        document.querySelectorAll('.poker-playerbox.active').forEach(function (el) {
          el.classList.remove('active');
        });
      }
      var obj = document.querySelector(".game-playerbox-".concat(player_number));
      if (obj) {
        obj.classList.add('active');
      }
    }
  }, {
    key: "setInactive",
    value: function setInactive() {
      var player_number = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      if (player_number == -1) {
        this.setActive(-1);
        return;
      }
      var obj = document.querySelector(".game-playerbox-".concat(player_number));
      if (obj) {
        obj.classList.remove('active');
      }
    }
  }, {
    key: "removeBoxes",
    value: function removeBoxes() {
      var _iterator = _createForOfIteratorHelper(this.playerboxes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var box = _step.value;
          box.remove();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.playerboxes = [];
    }
  }]);
}();
module.exports = Sidebar;